import { Autocomplete, TextField } from '@mui/material';

export interface ContractOption {
    id: number;
    label: string;
}

interface ContractSelectorProps {
    options: ContractOption[];
    value: ContractOption;
    onChange: (option: ContractOption | null) => void;
    label?: string;
}

export default function ContractSelector({
    options,
    value,
    onChange,
    label = 'Seleccioná un contrato'
}: ContractSelectorProps) {
    return (
        <Autocomplete
            options={options}
            value={value}
            onChange={(_, newVal) => onChange(newVal)}
            getOptionLabel={(opt) => opt?.label ?? ''}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            renderInput={(params) => <TextField {...params} label={label} size="small" />}
            disableClearable
            fullWidth
        />
    );
}
